import React, {useEffect,  useState} from "react";

import {Card, CardBody, Col, Container,  Row} from "reactstrap";

import BreadCrumb from "../../../Components/Common/BreadCrumb";

import locale from "antd/es/date-picker/locale/pt_BR";
import {Avatar, DatePicker} from "antd";

import ApiService from "../util/ApiService";
import Skeleton from "react-loading-skeleton";
import dayjs from "dayjs";
import CustomPagination from "../util/CustomPagination";

const {RangePicker} = DatePicker;
const ScaleRegisterPage = () => {

    document.title = "Lançamento Escala | Plantão Rápido";
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [showScalePostingModal, setShowScalePostingModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});


    const [filters, setFilters] = useState({
        dateRange: [],
        date_start: null,
        date_end: null,
    });


    const [arraScale, setArrayScale] = useState([]);


    const handleScalePostingModalClose = () => {
        setShowScalePostingModal(false);
    };

    const handleScalePostingModal = () => {
        setShowScalePostingModal(true);
    };


    const fetchArray = async (page) => {

        try {
            setLoadingSearch(true);
            // Monta os parâmetros, apenas incluindo aqueles que estão definidos
            const params = {
                page: page,
                datestart: filters.datestart ? filters.datestart : null,
                dateend: filters.dateend ? filters.dateend : null,
            };

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}scale/posting-list`,
                params,
                true
            );
            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setArrayScale(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});


        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSearch(false);
        }
    };


    useEffect(() => {
        fetchArray();

    }, []);


    const handleClearFilters = () => {
        setFilters({
            datestart: null,
            dateend: null,
        });

    };


    const handleSearchFiltersChange = (key, value) => {

        setFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };


    return (
        <>

            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <BreadCrumb title="Histórico Gerar Plantões" pageTitle="Escala Padrão"/>


                        <Row className="g-4 mb-4">
                            <div className="row mt-4 ">
                                <div className="col-4 form-group">
                                    <label>Data Histórico</label>
                                    <div className="form-control">
                                        <RangePicker
                                            style={{border: "none", boxShadow: "none"}}
                                            variant="outlined"
                                            locale={locale}
                                            format="DD/MM/YYYY"  // Mostra em DD/MM/YYYY na tela
                                            className="range-picker-custom"
                                            value={filters?.dateRange?.length > 0 ? filters?.dateRange : null}
                                            onChange={(dates) => {
                                                if (dates) {
                                                    handleSearchFiltersChange("dateRange", dates);
                                                    handleSearchFiltersChange("datestart", dayjs(dates[0]).format("YYYY-MM-DD"));
                                                    handleSearchFiltersChange("dateend", dayjs(dates[1]).format("YYYY-MM-DD"));
                                                } else {
                                                    handleSearchFiltersChange("dateRange", []);
                                                    handleSearchFiltersChange("datestart", null);
                                                    handleSearchFiltersChange("dateend", null);
                                                }
                                            }}
                                        />

                                    </div>
                                </div>
                                <div className=" d-flex justify-content-end">
                                    <button type="button" className="btn mr-1 me-2"  onClick={() =>handleClearFilters()}>
                                        <i className="fa fa-eraser"></i> Limpar Filtros
                                    </button>


                                    <button type="button"
                                        className="mr-1 me-2 btn btn-success"
                                        onClick={() => fetchArray(1)}
                                        disabled={loadingSearch}
                                    >

                                        <i className={`fa ${loadingSearch ? "spinner-border spinner-border-sm me-2" : "fa-search"}`}></i>{" "}
                                        {loadingSearch ? "Buscando..." : "Buscar"}
                                    </button>
                                </div>
                            </div>
                        </Row>
                        <Row className="gy-2 mb-2" id="candidate-list">
                            {  loadingSearch ? (
                                <Card className="mb-1 p-2 shadow-sm" style={{fontSize: "12px"}}>
                                    <CardBody className="d-flex justify-content-between align-items-center p-2">
                                        <Skeleton circle width={40} height={40} className="me-2"/>
                                        <Skeleton width={120} height={12}/>
                                        <Skeleton width={100} height={10}/>
                                        <Skeleton width={140} height={10}/>
                                        <Skeleton width={100} height={10}/>
                                        <Skeleton width={60} height={15}/>
                                        <Skeleton width={80} height={10}/>
                                        <Skeleton circle width={40} height={40} className="me-2"/>
                                        <Skeleton width={100} height={12}/>
                                        <Skeleton width={20} height={20} className="me-1"/>
                                        <Skeleton width={20} height={20}/>
                                    </CardBody>
                                </Card>
                            ) : (
                                arraScale?.length > 0 ? (
                                    arraScale.map((scale) => (
                                        <Col lg={12} key={scale.id}>
                                            <Card className="mb-1 p-2 shadow-sm card-hover">
                                                <CardBody
                                                    className="card-body d-flex justify-content-between align-items-center p-2">

                                                    {/* 🏥 Hospital + Localização */}
                                                    <div className="col-4 d-flex align-items-center">
                                                        <Avatar
                                                            src={process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"}
                                                            size={40}
                                                            className="me-2"
                                                        />
                                                        <div>
                                                            <h6 className="mb-1 fw-bold">{scale.hospital?.name || "Local não informado"}</h6>
                                                            <p className="text-muted mb-0">
                                                                <i className="fa fa-map-marker text-info me-1"></i>
                                                                {scale.hospital?.city_name || "Cidade não especificada"}, {scale.hospital?.uf || "UF não especificada"}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* 📅 Datas e Informações */}
                                                    <div className="col-4">
                                                        <p className="text-muted mb-0">
                                                            <i className="fa fa-calendar-alt text-primary me-1"></i>
                                                            {dayjs(scale.date_start).format('DD/MM/YYYY')} - {dayjs(scale.date_end).format('DD/MM/YYYY')}
                                                        </p>
                                                        <p className="text-muted mb-0">
                                                            <i className="fa fa-calendar-alt text-primary me-1"></i>
                                                            <span
                                                                className={`badge ${scale.department?.name ? "bg-success" : "bg-secondary"} text-white`}>
                                                                {scale.department?.name || "Departamento não informado"}
                                                            </span>
                                                        </p>
                                                    </div>
                                                    <div className="row col-4">
                                                        {scale.user && (
                                                        <div className="col-12 mb-3">
                                                            <div className="d-flex align-items-center">
                                                                <Avatar
                                                                    src={scale.user?.profile_image || process.env.REACT_APP_URL_STORAGE + 'src/perfil_icone.png'}
                                                                    size={32}
                                                                    className="me-2"
                                                                />
                                                                <div>
                                                                    <span
                                                                        className="mb-0 fw-semibold">{scale.user?.name || "Usuário não informado"}</span><br/>
                                                                    <small><em>Responsável Escala</em></small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        ) }

                                                        {scale?.logged && (
                                                        <div className="col-12">
                                                            <div className="d-flex align-items-center">
                                                                <Avatar
                                                                    src={scale?.logged?.profile_image || process.env.REACT_APP_URL_STORAGE + 'src/perfil_icone.png'}
                                                                    size={32}
                                                                    className="me-2"
                                                                />
                                                                <div>
                                                                    <span
                                                                        className="mb-0 fw-semibold">{scale?.logged?.name || "Usuário não informado"}</span><br/>
                                                                    <small><em>Operador </em></small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        )}
                                                    </div>



                                                </CardBody>
                                            </Card>
                                        </Col>
                                    ))
                                ) : (
                                    <div className="alert alert-primary" role="alert">
                                        Nenhum histórico de lançamento encontrado.
                                    </div>
                                )
                            )}


                            <CustomPagination
                                className="mt-4"
                                pagination={pagination}
                                onChange={(page) => fetchArray(page, false)}
                            />
                        </Row>
                    </Container>
                </div>
            </React.Fragment>


            {showScalePostingModal && (
                <ScalePostingModal
                    show={showScalePostingModal}
                    handleClose={handleScalePostingModalClose}

                />
            )}
        </>
    )
        ;
};

export default ScaleRegisterPage;
